import React, { useEffect, useState } from "react";
import eventEmitter from "../../../shared/events";

import Modal from "../../../components/modal";
import NoteLoader from "../../../components/notes/components/note-loader";
import PaginatedTable from "../../../components/table";

import { buildColumns } from "../lib/constants";
import { getTasks } from "../../../components/task-list/lib/taskData";
import { SECTION_MAP } from "../../../components/task-list/lib/constants";

const TaskList = ({ usersWithAssignments, disableNotes, ...props }) => {
    const [noteSettings, setNoteSettings] = useState(null);

    useEffect(() => {
        eventEmitter.on("UPDATE_NOTE_SETTINGS", updateNoteSettings);

        return () => {
            eventEmitter.removeListener("UPDATE_NOTE_SETTINGS", updateNoteSettings);
        };
    }, []);

    const updateNoteSettings = (newSettings) => {
        setNoteSettings({ ...newSettings, taskType: SECTION_MAP[props.taskType].noteKey, isReadOnly: disableNotes });
    };

    const getTaskData = (page, pageSize, sorted, filtered) => {
        const newFilter = filtered.filter((f) => f.id !== "taskType");

        return getTasks(props.taskType, page, pageSize, sorted, newFilter, "assignment");
    };

    const updateSelectedUpc = (obj, isRemove) => {
        if (isRemove === "true") {
            props.setSelectedProducts(props.selected.filter((i) => i.key !== obj.key));
        } else {
            props.setSelectedProducts([...props.selected, obj]);
        }
    };

    const setAllUpcs = (selections) => {
        props.setSelectedProducts([...selections]);
    };

    const updateTeamFilter = (team) => {
        props.setTeamFilter(team);
    };

    const closeNotesModal = () => {
        setNoteSettings(null);
    };

    const selectedIds = props.selected.map((s) => s.key);

    return (
        <div>
            <PaginatedTable
                appendSettings={props.appendSettings}
                getData={getTaskData}
                columns={buildColumns(
                    updateSelectedUpc,
                    setAllUpcs,
                    selectedIds,
                    props.locations,
                    props.assignments,
                    props.statuses,
                    usersWithAssignments,
                    updateTeamFilter,
                    props.taskType
                )}
                showPagination={true}
                updatePulse={props.updatePulse}
            />

            <Modal
                show={!!noteSettings}
                onClose={closeNotesModal}
            >
                <NoteLoader settings={noteSettings} />
            </Modal>
        </div>
    );
};

export default TaskList;
